import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useParams, useNavigate } from '@thd-olt-component-react/router';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import {
  Pagination,
  PaginationCompact,
  PaginationItem
} from '@one-thd/sui-atomic-components';
import {
  params,
  shape as shapeType,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { MAX_INDEXABLE_PAGES } from '../constants';

const QaPageLinks = ({
  itemId = '',
  channel = 'desktop',
  paginationProps = {}
}) => {
  const navigate = useNavigate();

  const {
    page,
    count = 1,
    onChange = () => { }
  } = paginationProps;
  const { channel: contextChannel, path } = useContext(ExperienceContext);
  const { page: ppqPageNumber } = useParams();
  const isMobile = channel === 'mobile' || contextChannel === 'mobile';

  const { data, error, loading } = useDataModel('product', {
    skip: !itemId,
    variables: { itemId }
  });

  if (!data || error || loading) {
    return null;
  }

  const canonicalUrl = data?.product?.identifiers?.canonicalUrl;
  const ppqUrl = canonicalUrl?.replace('/p/', '/p/questions/');

  const isPPQPage = path.includes('/p/questions/');
  const lastPageToIndex = Math.min(count, MAX_INDEXABLE_PAGES);

  // Determine active page number based on either the ppq page param or the passed in active page prop
  const activePageNumber = (isPPQPage && !!ppqPageNumber)
    ? Number.parseInt(ppqPageNumber, 10)
    : page;

  const handleChange = (event, value) => {
    event.preventDefault();
    if (isPPQPage && ppqUrl) {
      navigate(`${ppqUrl}/${value}`);
    }

    onChange(event, value);
  };

  const getPaginationItem = (item) => {
    // Business rule
    // don't link past the last page with content or MAX_INDEXABLE_PAGES so as to avoid wasting crawl budget
    const includeHref = item?.page && item.page <= lastPageToIndex && !!ppqUrl;
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <PaginationItem {...item} href={includeHref ? `${ppqUrl}/${item.page}` : undefined} />;
  };

  const componentProps = {
    ...paginationProps, // declared first to allow overriding any props if needed
    onChange: handleChange,
    renderItem: getPaginationItem,
    page: activePageNumber
  };

  return (
    <div data-component="QaPageLinks">
      {isMobile
        // eslint-disable-next-line react/jsx-props-no-spreading
        ? <PaginationCompact {...componentProps} />
        // eslint-disable-next-line react/jsx-props-no-spreading
        : <Pagination {...componentProps} />}
    </div>
  );
};

QaPageLinks.displayName = 'QaPageLinks';

QaPageLinks.propTypes = {
  itemId: PropTypes.string,
  channel: PropTypes.string,
  paginationProps: PropTypes.shape({
    page: PropTypes.number,
    count: PropTypes.number,
    onChange: PropTypes.func
  })
};

QaPageLinks.propTypes = {
  itemId: PropTypes.string,
  channel: PropTypes.string,
  paginationProps: PropTypes.shape({})
};

QaPageLinks.dataModel = {
  product: params({
    itemId: stringType().isRequired()
  }).shape({
    dataSource: stringType(),
    identifiers: shapeType({
      canonicalUrl: stringType()
    })
  })
};

export { QaPageLinks };